/* eslint-disable unicorn/no-array-for-each */
document.addEventListener('DOMContentLoaded', () => {
  const mobileBurger = document.querySelector('[data-js="toggle-mobile-menu"]')
  const mobileMenu = document.querySelector('[data-js="mobile-menu"]')
  const cookieMessage = document.querySelector('[data-js="cookie-msg"]')
  const cookieMessageClose = document.querySelectorAll('[data-js="cookie-msg-close"]')
  const openChat = document.querySelector('[data-js="chat-open-button"]')
  const closeChat = document.querySelector('[data-js="modal-close-chat"]')
  const chatModal = document.querySelector('[data-js="chat-modal"]')
  const chatSendDataButton = document.querySelector('[data-js="modal-submit-chat"]')

  getData('./assets/source.json')
  .then(data => {
    const language = window.localStorage.getItem('language')
    chooseLang(data)
    renderPage(data, language)
  })

  if (window.localStorage.getItem('cookie') !== 'true') {
    cookieMessage.style.display = 'block'
    cookieMessageClose.forEach(el => el.addEventListener('click', () => {
      window.localStorage.setItem('cookie', true)
      cookieMessage.style.display = 'none'
    }))
  }

  openChat.addEventListener('click', () => {
    chatModal.classList.add('chat_active')
  })

  closeChat.addEventListener('click', () => {
    chatModal.classList.remove('chat_active')
  })

  chatSendDataButton.addEventListener('click', () => {
    sendChatData()
  })

  initSelect('chat-modal')

  mobileBurger.addEventListener('click', e => {
    e.currentTarget.classList.toggle('mobile-burger_active')
    mobileMenu.classList.toggle('mobile-menu_active')
  })

  function sendChatData() {
    if (!document.getElementById('your-name-chat').value) {
      return
    }

    if (!document.getElementById('contact-chat').value) {
      return
    }

    const data = {
      type: 'chat',
      name: document.getElementById('your-name-chat').value,
      social: document.querySelector('[data-js="chat-modal"] [data-contact-button]').dataset.contactButton,
      contact: document.getElementById('contact-chat').value
    }

    fetch('https://accs.biz/api/feedback', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(() => {
      document.getElementById('your-name-chat').value = ''
      document.getElementById('contact-chat').value = ''

      chatModal.classList.remove('chat_active')
    })
    // eslint-disable-next-line no-console
    .catch(error => console.error('Error:', error))
  }

  function initSelect(selector) {
    const modal = document.querySelector(`[data-js="${selector}"]`)
    const modalSocialListItems = modal.querySelectorAll('[data-contact-item]')

    modalSocialListItems.forEach(el => {
      el.addEventListener('click', () => {
        modal.querySelector('[data-contact-button] img').src = `./assets/icons/front/${el.dataset.contactItem}.svg`
        modal.querySelector('[data-contact-button]').dataset.contactButton = el.dataset.contactItem
        modal.querySelector('[data-contact-input]').placeholder = el.dataset.contactTitle
      })
    })
  }

  function chooseLang(data) {
    let language = window.localStorage.getItem('language')

    if (!language) {
      window.localStorage.setItem('language', 'ru')
      language = 'ru'
    }

    document.querySelectorAll(`[data-flag="${language}"]`).forEach(el => el.classList.add('header__lang-flag_active'))
    renderPage(data, language)

    const langFlags = document.querySelectorAll('[data-flag]')
    langFlags.forEach(el => {
      el.addEventListener('click', e => {
        renderPage(data, e.currentTarget.dataset.flag)

        window.localStorage.setItem('language', e.currentTarget.dataset.flag)

        langFlags.forEach(el => el.classList.remove('header__lang-flag_active'))
        document.querySelectorAll(`[data-flag="${e.currentTarget.dataset.flag}"]`).forEach(el => el.classList.add('header__lang-flag_active'))
      })
    })
  }

  function renderPage(data, lang) {
    const dataArray = data.localization[lang]
    const menu = document.querySelectorAll('[data-local="menu"]')
    const faq = document.querySelectorAll('[data-local="faq"]')
    const socialsList = document.querySelectorAll('[data-local="socials"]')
    const modalItems = document.querySelectorAll('[data-local="modal"]')
    const footer = document.querySelectorAll('[data-local="footer"]')

    document.title = dataArray.title

    socialsList.forEach(list => list.querySelectorAll('li[data-contact-item]').forEach((el, ind) => {
      el.dataset.contactTitle = dataArray.socials[ind]
    }))

    change(menu, dataArray.menu)
    change(faq, dataArray.faq)
    change(footer, dataArray.footer)

    document.querySelectorAll('[data-contact-button] img').forEach(el => {
      el.src = './assets/icons/front/Telegram.svg'
    })
    document.querySelectorAll('[data-contact-button]').forEach(el => {
      el.dataset.contactButton = 'Telegram'
    })

    modalItems.forEach((el, ind) => {
      if (el.classList.contains('modal-form__item-input')) {
        el.placeholder = dataArray.modal[ind]
      } else {
        el.innerHTML = dataArray.modal[ind]
      }
    })

    // eslint-disable-next-line unicorn/consistent-function-scoping
    function change(elements, text) {
      elements.forEach((el, ind) => {
        el.innerHTML = text[ind]
      })
    }
  }
})

function getData(url, param) {
  return fetch(url, param)
  .then(response => response.json())
  .catch(error => {
    // eslint-disable-next-line no-console
    console.log(error)
  })
}
